import { render, staticRenderFns } from "./LexonKanbanSwimlaneTemplate.vue?vue&type=template&id=22584753&scoped=true&lang=pug"
import script from "./LexonKanbanSwimlaneTemplate.vue?vue&type=script&lang=ts"
export * from "./LexonKanbanSwimlaneTemplate.vue?vue&type=script&lang=ts"
import style0 from "./LexonKanbanSwimlaneTemplate.vue?vue&type=style&index=0&id=22584753&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22584753",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22584753')) {
      api.createRecord('22584753', component.options)
    } else {
      api.reload('22584753', component.options)
    }
    module.hot.accept("./LexonKanbanSwimlaneTemplate.vue?vue&type=template&id=22584753&scoped=true&lang=pug", function () {
      api.rerender('22584753', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LexonKanban/templates/LexonKanbanSwimlaneTemplate.vue"
export default component.exports